<adapt-collapsible-search-row #row
                              [result]="result"
                              [matches]="matches"
                              [href$]="href$"
                              [snippetTemplate]="snippet">
    <div class="d-flex flex-grow-1 align-items-center justify-content-between">
        <div class="d-flex flex-grow-0 me-2 align-items-center text-muted">
            <div class="d-flex align-items-center result-icon"
                 adaptTooltip="Value">
                <i class="fal fa-fw fa-heart fa-inverse"></i>
            </div>

            <div>
                @if (result.teamId) {
                    <adapt-link-team class="ms-2 me-2"
                                     [labelLinkDisabled]="true"
                                     [teamId]="result.teamId"></adapt-link-team>&gt;
                } @else {
                    <!-- only org-wide p&v exist in alto -->
                    <ng-container *adaptIfAlto="false"> <span class="ms-2 me-2">Organisation</span>&gt; </ng-container>
                }
            </div>
        </div>

        <div class="flex-grow-1 text-break d-flex align-items-center">
            <adapt-highlighted-text [needle]="keyword"
                                    [haystack]="result.name"></adapt-highlighted-text>
        </div>
    </div>
</adapt-collapsible-search-row>

<ng-template #snippet
             let-match="match">
    <!-- custom styling for behaviours -->
    @if (isBehaviour(match)) {
        <em class="flex-basis-100">
            @if (getBehaviour(match); as currBehaviour) {
                <i [adaptTooltip]="currBehaviour.tooltip"
                   [ngClass]="['text-' + currBehaviour.type, currBehaviour.icon, 'behaviour-icon']"></i>
            }
            &ldquo;<adapt-highlighted-text [needle]="keyword"
                                    [haystack]="match.snippet"></adapt-highlighted-text>&rdquo;
        </em>
    } @else {
        <ng-container *ngTemplateOutlet="defaultSnippetTemplate; context: { match }"></ng-container>
    }
</ng-template>
